import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translationES } from '../assets/translations/translationES';
import { translationPT } from 'assets/translations/translationPT';
import { translationEN } from 'assets/translations/translationEN';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'es',
    debug: false,
    supportedLngs: ['en', 'es', 'pt'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      es: {
        translation: {
          ...translationES,
        },
      },
      en: {
        translation: {
          ...translationEN,
        },
      },
      pt: {
        translation: {
          ...translationPT,
        },
      },
    },
  });

export default i18n;
